import React from 'react';
import './Products.css';
import { RadioTower, AudioWaveform, Speaker, AudioLines, RadioReceiver } from 'lucide-react';

const Products = () => {
  const products = [
    {
      id: 1,
      title: 'مرسلات FM',
      description: 'مرسلات FM و LPFM للبث مع مشغلات DDS ومليئة بالميزات لجميع محطات الراديو.',
      buttonText: 'المزيد عن المرسلات',
      icon: <RadioTower size={48} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/products/fm-transmitters'
    },
    {
      id: 2,
      title: 'معالجات الصوت',
      description: 'معالجات صوت FM بأحدث التقنيات المصممة للاستخدام في محطتك الإذاعية',
      buttonText: 'المزيد عن المعالجات',
      icon: <AudioLines size={48} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/products/audio-processors'
    },
    {
      id: 3,
      title: 'مضخمات FM',
      description: 'مضخمات بث FM مع مدخلات RF مزدوجة ومليئة بالميزات لجميع محطات الراديو.',
      buttonText: 'مضخمات FM',
      icon: <RadioReceiver size={48} strokeWidth={1.5} />,
      link: 'https://aquabroadcast.co.uk/products/fm-amplifiers'
    }
  ];

  const handleProductClick = (link) => {
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  return (
    <section id="products" className="section">
      <div className="container">
        <h2 className="section-title">منتجاتنا</h2>
        <div className="products-grid">
          {products.map((product) => (
            <div 
              key={product.id} 
              className="product-card"
              onClick={() => handleProductClick(product.link)}
              style={{ cursor: 'pointer' }}
            >
              <div className="product-icon">{product.icon}</div>
              <h3>{product.title}</h3>
              <p>{product.description}</p>
              <button className="product-button">
                {product.buttonText}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
